module.exports = __webpack_public_path__ + "img/medium-link.fac14a40.png";